import { useAsync } from '@react-hookz/web';
import { useEffect } from 'react';
const defaultQueryFunction = () => Promise.resolve({
  offerCode: ''
});
export const useOfferCodeQuery = ({
  enabled,
  queryFn: queryFunction = defaultQueryFunction
}) => {
  const [{
    status,
    result: data,
    error
  }, actions] = useAsync(queryFunction);
  useEffect(() => {
    if (enabled && status === 'not-executed') {
      actions.execute();
    }
  }, [enabled, status, actions]);
  return {
    status,
    data,
    error
  };
};